import { Model } from 'pinia-orm';
import FilterGroup from "./FilterGroup";
import Filter from "./Filter";

export default class FilterGroupFilter extends Model {

    static get entity () {
        return 'filter-group-filters';
    }

    static get primaryKey () {
        return ['filter_id', 'filter_group_id'];
    }

    static fields () {
        return {
            id: this.uid(),
            filter_id: this.attr(null),
            filter_group_id: this.attr(null),
            order: this.attr({}),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // Relationships
            filter_group: this.belongsTo(FilterGroup, 'filter_group_id'),
            filter: this.belongsTo(Filter, 'filter_id'),
        }
    }
}
